import { Box, CircularProgress, Typography } from '@mui/material';
import CardLayout from '../../UIComponents/CardLayout';
import { useNavigate } from 'react-router-dom';
import { downloadStaticFile, isConsent } from '../../Services/httpCalls';
import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';

import GovButton from '../../UIComponents/Buttons/GovButton';
import useUser from '../../hooks/useUser';

const RegistrationForm = () => {
  const navigate = useNavigate();
  const { isNewUser } = useUser();
  const [isPending, setIsPending] = useState(false);

  const downloadStaticKad = async () => {
    try {
      await downloadStaticFile('kad.pdf');
    } catch (err) {}
  };

  const downloadStaticSpecialtyCodes = async () => {
    try {
      await downloadStaticFile('ergani_specialty_codes.pdf');
    } catch (err) {}
  };

  const handleNavigation = async () => {
    if (isNewUser) {
      navigate('/request');
      return;
    }

    setIsPending(true);

    try {
      await isConsent(true);
    } catch (error) {
      enqueueSnackbar('Παρουσιάστηκε σφάλμα στον έλεγχο πιστοποίησης.', {
        variant: 'error',
        autoHideDuration: 2000,
      });
    } finally {
      setIsPending(false);
      navigate('/registry-review');
    }
  };

  return (
    <Box sx={{ my: 3 }}>
      <Typography variant="h2" sx={{ my: 2 }}>
        Οι κωδικοί σύνδεσης στο Taxisnet που χρησιμοποιήσατε δεν αντιστοιχούν σε
        πιστοποιημένο χρήστη.
      </Typography>
      <Typography>Πιστοποιημένος χρήστης θεωρείται ο</Typography>
      <Typography component="div">
        <ul>
          <li style={{ paddingBottom: '20px' }}>
            Εργαζόμενος στον πολιτιστικό και δημιουργικό τομέα όπου είναι το
            φυσικό πρόσωπο που έχει παράσχει εργασία με σύμβαση ή σχέση
            εξαρτημένης εργασίας, που αποδεικνύεται από μία (1) τουλάχιστον
            ημέρα απασχόλησης, σύμφωνα με τα στοιχεία που αντλούνται από το
            Πληροφοριακό Σύστημα ΕΡΓΑΝΗ ΙΙ (απο το 2019) σε{' '}
            <span
              className="hoverable-text"
              onClick={downloadStaticSpecialtyCodes}
            >
              κωδικό ειδικότητας
            </span>{' '}
            που εμπίπτει στον πολιτιστικό και δημιουργικό τομέα.
          </li>
          <li style={{ paddingBottom: '20px' }}>
            Επαγγελματίας του πολιτιστικού και δημιουργικού τομέα είναι το
            φυσικό πρόσωπο που δραστηριοποιείται σε έναν από τους{' '}
            <span className="hoverable-text" onClick={downloadStaticKad}>
              Κωδικούς Αριθμούς Δραστηριότητας (ΚΑΔ)
            </span>{' '}
            του πολιτιστικού και δημιουργικού τομέα με ενεργό ΚΑΔ.
          </li>
          <li style={{ paddingBottom: '20px' }}>
            Εργαζόμενος σε υποστηρικτικές δραστηριότητες του πολιτιστικού και
            δημιουργικού τομέα είναι το φυσικό πρόσωπο που έχει παράσχει εργασία
            με σύμβαση ή σχέση εξαρτημένης εργασίας, που αποδεικνύεται από μία
            (1)τουλάχιστον ημέρα απασχόλησης σύμφωνα με τα στοιχεία που
            αντλούνται από το Π.Σ. ΕΡΓΑΝΗ ΙΙ (απο το 2019) σε{' '}
            <span
              className="hoverable-text"
              onClick={downloadStaticSpecialtyCodes}
            >
              κωδικό ειδικότητας
            </span>{' '}
            που αποτελεί υποστηρικτική δραστηριότητα του πολιτιστικού και
            δημιουργικού τομέα.
          </li>
          <li style={{ paddingBottom: '20px' }}>
            Επαγγελματίας υποστηρικτικών δραστηριοτήτων του πολιτιστικού και
            δημιουργικού τομέα είναι το φυσικό πρόσωπο που δραστηριοποιείται σε
            έναν από τους ΚΑΔ υποστηρικτικών δραστηριοτήτων του πολιτιστικού και
            δημιουργικού τομέα με ενεργό ΚΑΔ.
          </li>
        </ul>
      </Typography>
      <CardLayout title="Προσοχή" type="shadow">
        <Typography sx={{ mb: 6 }}>
          Μπορείτε να χρησιμοποίησετε την εφαρμογή για να δείτε τα στοιχεία
          υπάρχουσας αίτησης ή να δημιουργήσετε νέα αίτηση εγγραφής στο μητρώο
          απασχολούμενων του πολιτιστικού και δημιουργικού τομέα ως μη
          πιστοποιημένος χρήστης.
        </Typography>
      </CardLayout>

      <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <GovButton
          ariaLabel={'Συνέχεια'}
          type={'submit'}
          variant="contained"
          background={'#006736'}
          hoverBackground={'#154a2b'}
          borderColor={'#006736'}
          onClick={handleNavigation}
          disabled={isPending}
        >
          Συνέχεια
        </GovButton>
        {isPending && (
          <CircularProgress size={24} role="progressbar" aria-label="Φόρτωση" />
        )}
      </Box>
    </Box>
  );
};

export default RegistrationForm;
